var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("quotation-list", {
        ref: "qutFcl",
        attrs: { "quotation-type": _vm.PriceConstant.QUOTATION_FCL }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }